import { Collection } from '@/kernel/collection';

import StringCell from '@/components/cells/string-cell.vue';
import DateCell from '@/components/cells/date-cell.vue';
import BooleanCell from '@/components/cells/boolean-cell.vue';
import EditCollectionCell from '@/components/cells/edit-collection-cell.vue';

import { DateRangeFilterAdapter, SelectFilterAdapter } from '@/kernel/adapters';

import DateRangeInput from '@/components/inputs/date-range-input.vue';
import TextInput from '@/components/inputs/text-input.vue';
import TextareaInput from '@/components/inputs/textarea-input.vue';
import CheckboxInput from '@/components/inputs/checkbox-input.vue';
import SelectInput from '@/components/inputs/select-input.vue';
import DateInput from '@/components/inputs/date-input.vue';

const isPublishedOptions = [
  {value: null, label: 'Any'},
  {value: false, label: 'Unpublished'},
  {value: true, label: 'Published'}
];

export class Announcement extends Collection {
  config = {
    autoRoute: true,
    requiresSuperAdmin: true,
    key: 'announcement',
    pluralLabel: 'Announcements',
    singleLabel: 'Announcement',
    indexUrl: '/announcement',
    createUrl: '/announcement/create',
    searchKeys: ['name'],
    editUrlPrefix: '/announcement',
    idKey: 'id',
    nameKey: 'name',
    payloadEndpoint: '/announcement',
    defaultSort: {
      key: 'name',
      order: 1
    },
    indexColumns: [
      {name: 'Actions', key: 'edit', sortable: false, cell: EditCollectionCell, props: {collection: 'announcement'}},
      {name: 'Name', key: 'name', sortable: true, cell: StringCell},
      {name: 'Is Published', key: 'isPublished', sortable: false, cell: BooleanCell},
      {name: 'Updated', key: 'updatedAt', sortable: true, cell: DateCell},
      {name: 'Created', key: 'createdAt', sortable: true, cell: DateCell}
    ],
    indexFilters: [
      {key: 'isPublished', label: 'Is Published', input: SelectInput, adapter: SelectFilterAdapter, props: {label: 'Is Published', options: isPublishedOptions}},
      {key: 'updatedAt', label: 'Updated at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Updated at'}},
      {key: 'createdAt', label: 'Created at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Created at'}}
    ],
    createFormFields: [
      {key: 'isPublished', label: 'Is Published', input: CheckboxInput, props: {label: 'Is Published'}},
      {key: 'date', label: 'Date', input: DateInput, props: {label: 'Date'}},
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'headline', label: 'Headline', input: TextareaInput, props: {label: 'Headline'}},
      {key: 'excerpt', label: 'Excerpt', input: TextareaInput, props: {label: 'Excerpt'}},
      {key: 'link', label: 'Link', input: TextInput, props: {label: 'Link'}}
    ],
    editFormFields: [
      {key: 'isPublished', label: 'Is Published', input: CheckboxInput, props: {label: 'Is Published'}},
      {key: 'date', label: 'Date', input: DateInput, props: {label: 'Date'}},
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'headline', label: 'Headline', input: TextareaInput, props: {label: 'Headline'}},
      {key: 'excerpt', label: 'Excerpt', input: TextareaInput, props: {label: 'Excerpt'}},
      {key: 'link', label: 'Link', input: TextInput, props: {label: 'Link'}}
    ]
  }
}